export default class Credential {
  constructor(email, password) {
    this.email = email;
    this.password = password;
  }
}
